module.exports = "@Pass{\n@DynamicState(dynamic-cull)\n#extension GL_OES_standard_derivatives : enable\n@BlendFunc(SRC_ALPHA,ONE_MINUS_SRC_ALPHA)\nFS_PREC(mediump,float)\n\n@import \"gltf-varying-vertex\"\n\n@import \"gltf-fragment\"\n}"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/Shaders/gltf-pbr-metallic-roughness.sort
// module id = 38
// module chunks = 0